import { Injectable } from "@angular/core";
import { Observable, first } from "rxjs";
import { HotelsViewModel, IHotelsFacade, makeHotelsViewModel } from "../model";
import { HotelsQuery } from "../services/hotels.query";
import { HotelsFiltersMetaData } from "./hotels.filters.config";
import { SortValueEnum } from "src/app/libs/ui/components/top-bar/enums/top-bar.enum";

@Injectable({
  providedIn: "root",
})
export class HotelsFacade implements IHotelsFacade {
  readonly hotels$: Observable<any> = this.hotelsQuery.hotels$; //TODO: Change to Hotels interface;
  readonly active$: Observable<any> = this.hotelsQuery.active$; //TODO: Change to Hotels interface;
  readonly filtersMetadata$: Observable<any> =
    this.hotelsQuery.filtersMetadata$; //TODO: Change to Hotels interface;
  readonly requestMetadata$: Observable<any> =
    this.hotelsQuery.requestMetadata$;
  readonly sort$: Observable<SortValueEnum> = this.hotelsQuery.sort$;
  readonly totalRecordsLeft$: Observable<number> =
    this.hotelsQuery.totalRecordsLeft$;
  readonly totalRecords$: Observable<number> =
    this.hotelsQuery.totalRecords$;
  readonly selectedQuickFilter$: Observable<any> =
    this.hotelsQuery.selectedQuickFilter$;
  readonly loadMoreActions$: Observable<any> =
    this.hotelsQuery.loadMoreActions$;
  readonly loading$: Observable<boolean> = this.hotelsQuery.loading$;
  readonly loaded$: Observable<boolean> = this.hotelsQuery.loaded$;
  readonly errors$: Observable<any> = this.hotelsQuery.errors$; //TODO: Change to Flights interface
  vm$!: Observable<HotelsViewModel>;

  constructor(private hotelsQuery: HotelsQuery,) {
    this.vm$ = makeHotelsViewModel([
      this.hotels$,
      this.active$,
      this.filtersMetadata$,
      this.requestMetadata$,
      this.sort$,
      this.totalRecordsLeft$,
      this.totalRecords$,
      this.selectedQuickFilter$,
      this.loadMoreActions$,
      this.loading$,
      this.loaded$,
      this.errors$,
    ]);
    this.saveFilterConfiguration(HotelsFiltersMetaData);
  }

  ngOnInit() {
    this.saveFilterConfiguration(HotelsFiltersMetaData);
  }

  saveFilterConfiguration(metadata: any) {
    this.hotelsQuery.saveFilterConfiguration(metadata);
  }
  getAllHotels() {
    return this.hotelsQuery.getAllHotels();
  }
  getHotelById(id: string | number) {
    //TODO: complete types
    return this.hotelsQuery.selectHotelById(id);
  }
  loadHotelFilterOptions(requestQuery: any) {
    this.saveFilterConfiguration(HotelsFiltersMetaData);
    this.hotelsQuery.loadHotelFilterOptions(requestQuery);
  }
  loadHotelsData(requestQuery: any) {
    this.hotelsQuery.loadHotelsData(requestQuery);
  }
  loadMoreHotelsData(requestQuery: any) {
    this.hotelsQuery.loadMoreHotelsData(requestQuery);
  }
  loadFilteredAndSortedHotels(filter: any, sort: any) {
    let requestQuery: any = {};
    this.requestMetadata$.pipe(first((res) => !!res)).subscribe((res) => {
      requestQuery = JSON.parse(JSON.stringify(res));
      requestQuery.hotelsCriteria.metadata.page = 1;
      requestQuery.filters = filter;
      requestQuery.sort = sort;
    });
    this.hotelsQuery.loadHotelsData(requestQuery);
  }
  setQuickFilter(selectedQuickFilter: any): void {
    this.hotelsQuery.setQuickFilter(selectedQuickFilter);
  }

}
